import { z } from 'zod'

export const SCHEMA_URI_PLAIN = 'https://folhafiscal.dev/schema/v1/export.json'
export const SCHEMA_URI_ENCRYPTED = 'https://folhafiscal.dev/schema/v1/export-encrypted.json'

const entrySnapshotSchema = z.object({
  status: z.enum(['calculado', 'pendente', 'erro']),
  dataPTAXAplicavel: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional(),
  cotacaoMoedaParaUSD: z.number().positive().optional(),
  dataCotacaoMoedaParaUSD: z.string().optional(),
  cotacaoUSDBRL: z.number().positive().optional(),
  valorUSD: z.number().nonnegative().optional(),
  valorBRL: z.number().nonnegative().optional(),
  calculadoEm: z.string().optional(),
  fontes: z.unknown().optional(),
  erro: z.unknown().optional(),
})

const entrySchema = z.object({
  id: z.string().uuid(),
  anoBase: z.number().int().min(2020).max(2099),
  tipo: z.enum(['rendimento', 'imposto_pago_exterior']),
  dataRecebimento: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  moedaOrigem: z.enum(['USD', 'CAD']),
  valorOriginal: z.number().positive(),
  pais: z.enum(['US', 'CA']),
  pagador: z.string().max(200).optional(),
  categoria: z.string().max(200).optional(),
  tag: z.string().max(200).optional(),
  descricao: z.string().max(2000).optional(),
  criadoEm: z.string(),
  atualizadoEm: z.string(),
  snapshot: entrySnapshotSchema,
})

const rateCacheEntrySchema = z.object({
  source: z.enum(['bcb', 'boc']),
  series: z.string(),
  date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  value: z.number().positive(),
  effectiveDate: z.string(),
  fetchedAt: z.string(),
})

export const exportPayloadPlainSchema = z.object({
  $schema: z.string().url(),
  version: z.literal(1),
  exportedAt: z.string(),
  anoBase: z.union([z.number(), z.literal('all')]),
  entries: z.array(entrySchema),
  rateCache: z.array(rateCacheEntrySchema).optional(),
  settings: z
    .object({
      knownCategorias: z.array(z.string()).default([]),
      knownTags: z.array(z.string()).default([]),
      knownPagadores: z.array(z.string()).default([]),
    })
    .optional(),
})
export type ExportPayloadPlain = z.infer<typeof exportPayloadPlainSchema>

export const exportPayloadEncryptedSchema = z.object({
  $schema: z.string().url(),
  version: z.literal(1),
  encrypted: z.literal(true),
  algorithm: z.literal('AES-GCM-256'),
  kdf: z.literal('PBKDF2-SHA256-600k'),
  salt: z.string(),
  iv: z.string(),
  ciphertext: z.string(),
})
export type ExportPayloadEncrypted = z.infer<typeof exportPayloadEncryptedSchema>

export const exportPayloadSchema = z.union([
  exportPayloadEncryptedSchema,
  exportPayloadPlainSchema,
])
export type ExportPayload = z.infer<typeof exportPayloadSchema>
